export const ALERT_DAY_THRESHOLD = 1;
export const HIGH_ALERT_DAY_THRESHOLD = 3;

export const TASK_REPLACE_QPS = {
  collection_id: undefined,
  collection_type: undefined,
  group_view_id: undefined,
  sub_collection_id: undefined,
  sub_collection_type: undefined,
  task_display_mode: undefined,
  task_drawer_id: undefined,
};

export const TASK_CUSTOM_DESCRIPTION = {
  payment_promise: {
    acknowledge: {
      icon: 'fas fa-sparkle text-agent',
      label: 'Review dates set by our agent',
    },
    complete: {
      icon: 'far fa-calendar-exclamation text-destructive',
      label: 'Log missing promise to pay dates',
    },
  },
};

export default {
  ALERT_DAY_THRESHOLD,
  HIGH_ALERT_DAY_THRESHOLD,
  TASK_REPLACE_QPS,
};
